export default __webpack_public_path__ + "static/media/factory__48.99574c82.jpg";